import React from 'react';
import { Link } from 'react-router-dom';
import './NotFound.css';

const NotFound = () => {
  return (
    <div className="not-found">
      <div className="not-found-container">
        <div className="not-found-content">
          <div className="not-found-icon">📸</div>
          <h1>404</h1>
          <h2>Page Not Found</h2>
          <p>
            Oops! It looks like this photo session got lost in the darkroom. 
            The page you're looking for doesn't exist.
          </p>
          
          <div className="not-found-actions">
            <Link to="/" className="btn btn-primary">
              Go Home
            </Link>
            <Link to="/gallery" className="btn btn-secondary">
              Browse Gallery
            </Link>
          </div>
          
          <div className="not-found-suggestions">
            <h3>Popular Pages</h3>
            <div className="suggestions-grid">
              <Link to="/gallery" className="suggestion-link">
                <span className="suggestion-icon">🖼️</span>
                <span>Photo Gallery</span>
              </Link>
              <Link to="/achievements" className="suggestion-link">
                <span className="suggestion-icon">🏆</span>
                <span>Achievements</span>
              </Link>
              <Link to="/about" className="suggestion-link">
                <span className="suggestion-icon">👤</span>
                <span>About Nicole</span>
              </Link>
              <Link to="/contact" className="suggestion-link">
                <span className="suggestion-icon">📧</span>
                <span>Contact</span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
